/**
 * Shopify Dawn Theme Custom Section Script
 * Component: Collection Discovery Grid Autoplay Video Lazyloader
 * Author: Iterative Lab
 * Version: 1.0.0
 */

(function() {
  'use strict';

  function initLazyVideos() {
    const lazyVideos = [].slice.call(document.querySelectorAll('video[data-lazy-video]'));

    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(videoEntry) {
          const video = videoEntry.target;
          
          if (videoEntry.isIntersecting) {
            // Element is on-screen, load and start video play
            const sources = video.querySelectorAll('source');
            sources.forEach(function(src) {
              const dataSrc = src.getAttribute('data-src');
              if (dataSrc) {
                src.setAttribute('src', dataSrc);
                src.removeAttribute('data-src');
              }
            });
            
            video.load();
            video.play().then(function() {
              video.classList.remove('lazy-video');
              video.setAttribute('preload', 'metadata');
            }).catch(function(error) {
              // Browser autoplay block fallback
              console.log('Autoplay restriction active:', error);
            });
            
            // We can stop observing if we want, or keep observing to pause when offscreen
            // Keeping observer active to pause when offscreen saves device battery and CPU!
          } else {
            // Element is off-screen, pause to conserve performance
            if (video && typeof video.pause === 'function') {
              video.pause();
            }
          }
        });
      }, {
        root: null, // default is browser viewport
        rootMargin: '100px', // start loading 100px before intersecting
        threshold: 0.1 // 10% visible
      });

      lazyVideos.forEach(function(video) {
        videoObserver.observe(video);
      });
    } else {
      // Fallback for older browsers without IntersectionObserver
      lazyVideos.forEach(function(video) {
        const sources = video.querySelectorAll('source');
        sources.forEach(function(src) {
          const dataSrc = src.getAttribute('data-src');
          if (dataSrc) {
            src.setAttribute('src', dataSrc);
          }
        });
        video.load();
        video.play().catch(function() {});
      });
    }
  }

  function initScrollReveal() {
    const sections = document.querySelectorAll('.collection-discovery-grid');
    
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function(sec) { sec.classList.add('is-revealed'); });
      return;
    }

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -5% 0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const section = entry.target;
          section.classList.add('is-revealed');
          
          const cards = section.querySelectorAll('.collection-card');
          cards.forEach(function(card, index) {
            // Add stagger delay (approx 120ms between cards)
            card.style.transitionDelay = (index * 120) + 'ms';
          });

          obs.unobserve(section);
        }
      });
    }, observerOptions);

    sections.forEach(function(section) {
      observer.observe(section);
    });
  }

  // Bind to DOMContentLoaded, and support Shopify Theme editor events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initLazyVideos();
      initScrollReveal();
    });
  } else {
    initLazyVideos();
    initScrollReveal();
  }

  // Register section select/deselect events for Shopify Section Editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('collection-discovery-grid') || event.target.querySelector('.collection-discovery-grid')) {
      initLazyVideos();
      initScrollReveal();
    }
  });
})();
